import getInstance from '@/external-libs/axios';

/**
 * Utils
 */
import { strongPasswordRulesURL } from '@/src/constants/urls/apiGatewayURLs';
import ServiceResponse from '@/src/models/ServiceResponse';

async function getStrongPasswordRules() {
  try {
    const axios = getInstance();
    const { data } = await axios.get(strongPasswordRulesURL);

    return new ServiceResponse({ data });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export default getStrongPasswordRules;
